import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

import { textOverflow } from "Utils/Styles";

const classNames = {
  root: `LinkWithTooltip`,
  tooltip: `Tooltip`,
  link: `Link`
};

export function useLinkWithTooltipStyles() {
  const { fonts } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [classNames.root, {}],
      tooltip: [
        classNames.tooltip,
        {
          display: `block`,
          width: `100%`,
          ...textOverflow
        }
      ],
      link: [
        classNames.link,
        {
          fontSize: fonts.mediumPlus.fontSize,
          ":hover, :active, :link, :visited": {
            textDecoration: `none`
          }
        }
      ]
    }),
    [fonts]
  );
}
